import { gql } from '@apollo/client';

export const DELETE_TRADE_MUTATION = gql`
  mutation DeleteTrade($id: Int!) {
    p {
      deleteTrade(id: $id) {
        success
        message {
          code
          message
        }
        content
      }
    }
  }
`;
